import { isLive, isMissionDone, missionDef, msUntilUtcMidnight, } from './missions';
export const MISSION_URGENT_MS = 60 * 60 * 1000;
export function missionsView(state, today, nowMs) {
    if (!state?.set || !isLive(state, today))
        return null;
    const set = state.set;
    const rows = set.ids.flatMap((id, slot) => {
        const def = missionDef(id);
        if (!def)
            return [];
        return [
            {
                slot,
                id,
                target: def.target,
                progress: Math.min(def.target, set.progress[slot] ?? 0),
                coins: def.coins,
                done: isMissionDone(set, slot),
                claimed: set.claimed[slot] === true,
            },
        ];
    });
    const doneCount = rows.filter((r) => r.done).length;
    const readyCount = rows.filter((r) => r.done && !r.claimed).length;
    const allClaimed = rows.length > 0 && rows.every((r) => r.claimed);
    const msLeft = msUntilUtcMidnight(nowMs);
    return {
        live: true,
        rows,
        doneCount,
        readyCount,
        allClaimed,
        bonusClaimed: set.bonusClaimed,
        bonusReady: allClaimed && !set.bonusClaimed,
        msLeft,
        urgent: readyCount > 0 && msLeft <= MISSION_URGENT_MS,
    };
}
/**
 * Is the next 00:00 UTC still today on the player's own clock? It picks the ALL DONE
 * stamp's words only ("later today" or "tomorrow"): the reset stays 00:00 UTC for
 * everyone, so a changed device clock changes a sentence and earns nothing.
 */
export function missionResetIsToday(nowMs, tzOffsetMin) {
    const localDay = (ms) => Math.floor((ms - (tzOffsetMin ?? new Date(ms).getTimezoneOffset()) * 60000) / 86400000);
    return localDay(nowMs) === localDay(nowMs + msUntilUtcMidnight(nowMs));
}
/** The running timer: "16:55:04", rounded up to the second (never "00:00:00" while time is left). */
export function missionClock(ms) {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(Math.floor(total / 3600))}:${pad(Math.floor(total / 60) % 60)}:${pad(total % 60)}`;
}
